// extracted by mini-css-extract-plugin
module.exports = {"newButton":"MobileNavBar_newButton__3TCxq"};